import { combineReducers } from "redux";

/* ------------- Reducers ------------- */
import ambassadorLeaderboardReducer from "./ambassadorLeaderboard";
import matchingGiftsReducer from "./matchingGifts";
import campaignSelfSignupReducer from "./campaignSelfSignup";
import givingFormV2Reducer from "./givingFormV2";
import customFieldsReducer from "./customFields";
import billingReducer from "./billing";
import spreedlyReducer from "./payments/spreedly";
import modalreducer from "./modal";
import entityReducer from "./entity";

export const reducers = combineReducers({
  ambassadorLeaderboard: ambassadorLeaderboardReducer,
  billing: billingReducer,
  entity: entityReducer,
  campaignSelfSignup: campaignSelfSignupReducer,
  givingFormV2: givingFormV2Reducer,
  customFields: customFieldsReducer,
  matchingGifts: matchingGiftsReducer,
  spreedly: spreedlyReducer,
  modal: modalreducer,
});
